var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 424,
    viewBox: "0 0 664 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.551 -69.2142C302.135 -77.0567 306.789 -94.4259 298.946 -108.009C291.104 -121.593 273.735 -126.247 260.151 -118.404C246.567 -110.562 241.913 -93.1929 249.756 -79.6094C257.598 -66.0259 274.967 -61.3718 288.551 -69.2142Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336.813 -42.4219C344.656 -28.8384 340.001 -11.4692 326.418 -3.62676C312.834 4.21568 295.465 -0.438373 287.623 -14.0219C279.78 -27.6054 284.434 -44.9746 298.018 -52.817C311.601 -60.6594 328.971 -56.0054 336.813 -42.4219Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.768 33.3452C213.61 46.9287 208.956 64.2979 195.373 72.1403C181.789 79.9827 164.42 75.3287 156.578 61.7452C148.735 48.1617 153.389 30.7925 166.973 22.9501C180.556 15.1076 197.925 19.7617 205.768 33.3452Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M374.679 23.1641C382.522 36.7476 377.868 54.1168 364.284 61.9592C350.701 69.8017 333.331 65.1476 325.489 51.5641C317.646 37.9806 322.301 20.6114 335.884 12.769C349.468 4.92654 366.837 9.58059 374.679 23.1641Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M298.568 99.7922C312.152 91.9497 316.806 74.5806 308.963 60.997C301.121 47.4135 283.752 42.7595 270.168 50.6019C256.585 58.4444 251.931 75.8135 259.773 89.397C267.616 102.981 284.985 107.635 298.568 99.7922Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440.301 -14.831C448.144 -1.24745 443.49 16.1217 429.906 23.9642C416.323 31.8066 398.954 27.1526 391.111 13.569C383.269 -0.0144564 387.923 -17.3836 401.506 -25.2261C415.09 -33.0685 432.459 -28.4145 440.301 -14.831Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M457.557 -79.2317C471.14 -87.0741 475.794 -104.443 467.952 -118.027C460.109 -131.61 442.74 -136.264 429.157 -128.422C415.573 -120.579 410.919 -103.21 418.762 -89.6268C426.604 -76.0433 443.973 -71.3892 457.557 -79.2317Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M412.546 88.7516C420.389 102.335 415.735 119.704 402.151 127.547C388.567 135.389 371.198 130.735 363.356 117.152C355.513 103.568 360.167 86.1989 373.751 78.3565C387.335 70.514 404.704 75.1681 412.546 88.7516Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M336.564 165.413C350.148 157.571 354.802 140.202 346.959 126.618C339.117 113.035 321.748 108.381 308.164 116.223C294.581 124.066 289.926 141.435 297.769 155.018C305.611 168.602 322.981 173.256 336.564 165.413Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M478.133 50.8849C485.976 64.4684 481.322 81.8376 467.738 89.68C454.154 97.5225 436.785 92.8684 428.943 79.2849C421.1 65.7014 425.754 48.3323 439.338 40.4898C452.922 32.6473 470.291 37.3014 478.133 50.8849Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M440.018 193.134C453.601 185.292 458.256 167.923 450.413 154.339C442.571 140.756 425.201 136.102 411.618 143.944C398.034 151.786 393.38 169.156 401.223 182.739C409.065 196.323 426.434 200.977 440.018 193.134Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M384.791 192.334C392.633 205.918 387.979 223.287 374.396 231.129C360.812 238.972 343.443 234.318 335.601 220.734C327.758 207.151 332.412 189.781 345.996 181.939C359.579 174.097 376.948 178.751 384.791 192.334Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M505.734 155.301C519.317 147.459 523.971 130.09 516.129 116.506C508.286 102.923 490.917 98.2686 477.334 106.111C463.75 113.953 459.096 131.323 466.939 144.906C474.781 158.49 492.15 163.144 505.734 155.301Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M281.372 164.485C289.215 178.068 284.561 195.438 270.977 203.28C257.394 211.123 240.024 206.468 232.182 192.885C224.339 179.301 228.994 161.932 242.577 154.09C256.161 146.247 273.53 150.901 281.372 164.485Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M205.39 241.147C218.974 233.304 223.628 215.935 215.785 202.352C207.943 188.768 190.574 184.114 176.99 191.956C163.407 199.799 158.752 217.168 166.595 230.752C174.437 244.335 191.807 248.989 205.39 241.147Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M609.307 -24.8484C617.15 -11.2649 612.495 6.10429 598.912 13.9467C585.328 21.7892 567.959 17.1351 560.117 3.55159C552.274 -10.0319 556.928 -27.4011 570.512 -35.2435C584.095 -43.086 601.465 -38.4319 609.307 -24.8484Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M533.325 51.8134C546.909 43.9709 551.563 26.6018 543.72 13.0183C535.878 -0.565247 518.509 -5.2193 504.925 2.62315C491.341 10.4656 486.687 27.8347 494.53 41.4183C502.372 55.0018 519.741 59.6558 533.325 51.8134Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M488.279 219.925C496.122 233.509 491.468 250.878 477.884 258.72C464.301 266.563 446.931 261.909 439.089 248.325C431.246 234.742 435.901 217.372 449.484 209.53C463.068 201.688 480.437 206.342 488.279 219.925Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M515.751 324.308C529.335 316.465 533.989 299.096 526.146 285.513C518.304 271.929 500.935 267.275 487.351 275.117C473.767 282.96 469.113 300.329 476.956 313.913C484.798 327.496 502.167 332.15 515.751 324.308Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M357.14 295.53C364.983 309.114 360.329 326.483 346.745 334.325C333.162 342.168 315.793 337.514 307.95 323.93C300.108 310.346 304.762 292.977 318.345 285.135C331.929 277.292 349.298 281.946 357.14 295.53Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M608.929 182.953C622.513 175.111 627.167 157.742 619.324 144.158C611.482 130.574 594.113 125.92 580.529 133.763C566.946 141.605 562.292 158.974 570.134 172.558C577.977 186.142 595.346 190.796 608.929 182.953Z",
    fill: "#B1C4C9",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.fcc46696b2161b2f541ae96a508a4a0b.svg";
export { ForwardRef as ReactComponent };